import { c as _c } from "react/compiler-runtime";
import { AktivitetskravBox } from "@/components/box/AktivitetskravBox";
import { HistoricEventsSummary } from "@/components/history/HistoricEventsSummary";
import { Page } from "@/components/page/Page";
import { Vurdering } from "@/components/view/Vurdering";
import { getViewItems } from "@/components/view/viewUtils";
import type { AktivitetskravVurdering } from "@/schema/aktivitetskravVurderingSchema";
interface Props {
  aktivitetskrav: AktivitetskravVurdering[];
}
export const Aktivitetskrav = t0 => {
  const $ = _c(9);
  const {
    aktivitetskrav
  } = t0;
  let t1;
  if ($[0] !== aktivitetskrav) {
    t1 = getViewItems(aktivitetskrav);
    $[0] = aktivitetskrav;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    activeVurdering,
    historicVurderinger
  } = t1;
  let t2;
  if ($[2] !== activeVurdering) {
    t2 = <AktivitetskravBox><Vurdering viewItem={activeVurdering} /></AktivitetskravBox>;
    $[2] = activeVurdering;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== historicVurderinger) {
    t3 = <HistoricEventsSummary historicVurderinger={historicVurderinger} />;
    $[4] = historicVurderinger;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Page>{t2}{t3}</Page>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};